var disputeAmountText = 'Dispute Amount';
var sorter = {
    sortedByText: 'Sorted by {{type}}, {{direction}}',
    sortBy: 'Sort by:',
    postedDate: 'Dispute Date',
    amount: disputeAmountText,
    status: 'Status',
    sortOrder: '{{type}}, sort in {{direction}} order',
    disputeId: 'Dispute ID',
    description: 'Transaction Description'
};
export default sorter;
//# sourceMappingURL=sorter.js.map